module.exports = __webpack_public_path__ + "img/nn2000.76eea9ab.jpg";